var _this = this,
  _jsxFileName = "/builds/EgNbCExi/0/ramsey-solutions/ramsey-plus/survey-ui/src/components/Question/Question.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* eslint-disable no-extra-parens */
import React from "react";
import PropTypes from "prop-types";
import { useField } from "formik";
import InputGroup from "../InputGroup/InputGroup";
import Alert from "../Alert/Alert";
import { displayableError } from "../../util/formikErrors";
import { questionPropType } from "../../prop-types";
var NPS = "NPS";
var parseResponse = function parseResponse(htmlResponse) {
  return {
    __html: htmlResponse
  };
};
var OptionalDescription = function OptionalDescription(_ref) {
  var question = _ref.question;
  if (!question.description) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "survey-Question-description",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("p", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 7
    }
  }, question.description));
};
var OptionalAlert = function OptionalAlert(_ref2) {
  var alias = _ref2.alias;
  var _useField = useField({
      name: alias
    }),
    _useField2 = _slicedToArray(_useField, 2),
    meta = _useField2[1];
  var error = displayableError(meta);
  return error ? /*#__PURE__*/React.createElement(Alert, {
    message: error,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 18
    }
  }) : "";
};

/**
 * Sets the component styling class
 * @param {string} questionType current question type
 * @return {string} component's layout class
 */
var layoutVariant = function layoutVariant(questionType) {
  var layoutClass = "survey-Question";
  if (questionType === NPS) {
    layoutClass += " survey-Question--fullWidth";
  }
  return layoutClass;
};
var Question = function Question(_ref3) {
  var question = _ref3.question,
    submission = _ref3.submission;
  return /*#__PURE__*/React.createElement(React.Fragment, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("fieldset", {
    className: "in-modeComfortable",
    "data-testid": "Question",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: layoutVariant(question.type),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "survey-Question-contentContainer",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("header", {
    className: "survey-Question-heading",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("legend", {
    className: "gzl-Heading gzl-Heading--secondary",
    dangerouslySetInnerHTML: parseResponse(question.title),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(OptionalDescription, {
    question: question,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "survey-Question-contentContainer",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(InputGroup, {
    question: question,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(OptionalAlert, {
    alias: question.alias,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "survey-Question-submit",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 11
    }
  }, submission)))));
};
Question.propTypes = {
  question: questionPropType.isRequired,
  submission: PropTypes.element.isRequired
};
export { Question as default };